import { createContext, useContext, useState } from "react";

const ZoomContext = createContext(null);

// 3 = grid cols on desktop. lower = bigger tiles.
const LEVELS = [2, 3, 4, 5, 6];

export const ZoomProvider = ({ children }) => {
  const [level, setLevel] = useState(2); // index into LEVELS -> 4 cols default

  const zoomIn = () => setLevel((l) => Math.max(0, l - 1));
  const zoomOut = () => setLevel((l) => Math.min(LEVELS.length - 1, l + 1));
  const cols = LEVELS[level];

  // Tailwind grid classes based on cols
  const gridClass = {
    2: "grid-cols-1 sm:grid-cols-2",
    3: "grid-cols-1 sm:grid-cols-2 md:grid-cols-3",
    4: "grid-cols-2 sm:grid-cols-3 md:grid-cols-4",
    5: "grid-cols-2 sm:grid-cols-4 md:grid-cols-5",
    6: "grid-cols-3 sm:grid-cols-4 md:grid-cols-6",
  }[cols];

  return (
    <ZoomContext.Provider value={{ level, cols, gridClass, zoomIn, zoomOut }}>
      {children}
    </ZoomContext.Provider>
  );
};

export const useZoom = () => useContext(ZoomContext) || { gridClass: "grid-cols-2 sm:grid-cols-3 md:grid-cols-4", zoomIn: () => {}, zoomOut: () => {} };
